import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useLoadDoctype } from "../../shared/hooks/useFrappeDoctype";
import { useGetLoggedUser } from "../../shared/hooks/useUser";

const LoginProtected = ({ children }) => {
    const { data: loggedUser, status } = useGetLoggedUser(true);
    const { data: restaurantSettings, status: restaurantSettingsStatus } =
        useLoadDoctype(
            "Restaurant Settings",
            "Restaurant Settings"
        );

    const [loggedIn, setLoggedIn] = useState();
    const kdsRoleProfile =
        restaurantSettings?.docs?.[0]?.kds_production_center?.trim?.();
    const kitchenRedirectTarget = kdsRoleProfile
        ? `/kds/${encodeURIComponent(kdsRoleProfile)}`
        : "/kds";

    useEffect(() => {
        // If user is not logged in, stay on /auth-login
        if (status === "error") {
            setLoggedIn(false);
            return;
        }

        if (status === "success") {
            if (!loggedUser) {
                setLoggedIn(false);
                return;
            }
            if (loggedUser.user_type && loggedUser.user_type !== "Website User") {
                setLoggedIn(true);
            } else {
                setLoggedIn(false);
            }
        }
    }, [loggedUser, status]);

    if (loggedIn) {
        const isKitchen = loggedUser?.role_profile_name === "Kitchen";

        if (isKitchen && restaurantSettingsStatus === "loading") {
            return null;
        }

        return (
            <Navigate
                to={isKitchen ? kitchenRedirectTarget : "/tables"}
                replace
            />
        );
    }
    return children;
};

export default LoginProtected;
